export default "__VITE_ASSET__d8f4e1cc__"